module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "con-box"
  }, [_c('div', {
    staticClass: "con-title"
  }, [_c('img', {
    staticClass: "header-logo",
    attrs: {
      "src": require("../../../static/img/logo2.png"),
      "width": "409",
      "height": "30",
      "alt": ""
    },
    on: {
      "click": _vm.initPath
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "divOpen"
  }, [(_vm.type == 0) ? _c('img', {
    staticClass: "qrocode header-icon",
    attrs: {
      "src": require("../../../static/img/type0.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 1) ? _c('img', {
    staticClass: "qrocode header-icon",
    attrs: {
      "src": require("../../../static/img/type1.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('img', {
    staticClass: "qrocode header-icon",
    attrs: {
      "src": require("../../../static/img/type2.png")
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('img', {
    staticClass: "qrocode header-icon",
    attrs: {
      "src": require("../../../static/img/type3.png")
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "logout",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.searchDetail
    }
  }, [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('img', {
    staticClass: "qrocode header-icon",
    attrs: {
      "src": require("../../../static/img/qrcode.png")
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "relative"
  }, [_c('span', {
    staticClass: "logout",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.openqrcode
    }
  }, [_vm._v("查看一企一码")]), _vm._v(" "), _c('viewer', {
    staticClass: "viewer",
    attrs: {
      "images": _vm.photo
    }
  }, _vm._l((_vm.photo), function(src, index) {
    return _c('img', {
      key: index,
      attrs: {
        "src": src
      }
    })
  }))], 1), _vm._v(" "), _c('i', {
    staticClass: "el-icon-circle-cross header-icon",
    staticStyle: {
      "margin-left": "20px",
      "margin-right": "5px"
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "logout",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("注销")])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "clear": "both"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "menu-box"
  }, [_c('navMenu')], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-41779ed0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/component/Header.vue
// module id = 1218
// module chunks = 2